import { account, error, money } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const SourceAccountsQuery = gql`
  query GetSourceAccounts($input: TransferOptionsInput) {
    transferOptions(input: $input) {
      ... on TransferOptions {
        id
        source {
          ... on GroupedAccounts {
            internal {
              ...account
              accountNumberLast4
            }
            external {
              ...account
              accountNumberLast4
            }
          }
        }
        type
        maxTransfer {
          ...money
        }
        transferEstimate
      }
      ... on TransferNotPossibleError {
        ...error
      }
    }
  }
  ${account}
  ${money}
  ${error}
`;

export default SourceAccountsQuery;
